import { Box } from "@material-ui/core";
import { useContext } from "react";
import AddressDataComponent from "../../../components/tempo/Shared/AddressDataComponent";
import FormBase from "../../../../forms/FormBase";
import { RecadastramentoContext } from "../../../../context/RecadastramentoContext";
import PersonalDataComponent from "../../../components/tempo/Shared/PersonalDataComponent";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";

export default function PersonalAddressDataStep() {
  const { state, dispatch } = useContext(RecadastramentoContext);

  const onInputPersonalChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onInputAddressChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  return (
    <div>
      
      <TmpTitleFormCustom marginTop={2} marginBottom={4}>
        Dados Pessoais
      </TmpTitleFormCustom>


      <Box mt={2}>

        <PersonalDataComponent
          PersonalDataForm={state.PersonalDataForm}
          onInputChange={onInputPersonalChange}
        />
      </Box>


      <TmpTitleFormCustom marginTop={3}  marginBottom={4}>
        Endereço Residencial
      </TmpTitleFormCustom>

      <Box mt={1}>

        <AddressDataComponent
          AddressDataForm={state.AddressDataForm}
          onInputChange={onInputAddressChange}
        />
      </Box>
    </div >
  );
}
